import React from 'react';

import * as FavouriteState from 'constants/FavouriteState';
import * as DisplayMode from 'constants/DisplayMode';

import {matchSortFunc} from 'rendering-commons/Sorting';

export default class League extends React.Component {
    static propTypes = {
        league: React.PropTypes.object,
        isLive: React.PropTypes.bool.isRequired,
        displayMode: React.PropTypes.object.isRequired,
        matches: React.PropTypes.object,
        matchElement: React.PropTypes.func,
        showBookmarks: React.PropTypes.bool.isRequired,
        showMatches: React.PropTypes.bool.isRequired,
        gridSelection: React.PropTypes.object,
        leagueClickCallback: React.PropTypes.func.isRequired,
        leagueFavouriteClickCallback: React.PropTypes.func,
        selectionToggleLeagueCallback: React.PropTypes.any
    };

    constructor(props) {
        super(props);

        this.state = {closed: true};

        this._onFavouriteClick = this._onFavouriteClick.bind(this);
        this._onClick = this._onClick.bind(this);
    }

    componentWillMount() {
        const {league, gridSelection} = this.props;

        if (this.props.isLive && gridSelection.get('leaguesExpanded').includes(league.get('id'))) {
            this.setState({closed: false});
        }
    }

    componentWillReceiveProps(nextProps) {
        const {league, gridSelection, isLive} = nextProps;

        if (league) {
            if (isLive && gridSelection.get('leaguesExpanded').includes(league.get('id'))) {
                this.setState({closed: false});
            }
        }
    }

    _onLeagueClick(sportId, id, e) {
        e.preventDefault();

        const {leagueClickCallback, selectionToggleLeagueCallback} = this.props;

        leagueClickCallback(sportId, id);

        if (selectionToggleLeagueCallback) {
            selectionToggleLeagueCallback({id: id, sportId: sportId, showMatches: true});
        }
    }

    _onFavouriteClick(e) {
        e.preventDefault();
        this.props.leagueFavouriteClickCallback(this.props.league);
    }

    _onClick(e) {
        e.preventDefault();
        this.setState({closed: !this.state.closed});

        const {league, selectionToggleLeagueCallback} = this.props;

        if (selectionToggleLeagueCallback) {
            selectionToggleLeagueCallback({id: league.get('id'), sportId: league.get('sportId'), showMatches: false});
        }
    }

    static renderMatch(matchId, props) {
        const matchProps = {
            matchId,
            matchStatsElement: props.matchStatsElement,
            mainScoreElement: props.mainScoreElement,
            additionalScoresElement: props.additionalScoresElement,
            additionalScoreElement: props.additionalScoreElement,
            matchClickCallback: props.matchClickCallback,
            matchFavouriteClickCallback: props.matchFavouriteClickCallback
        };

        const MatchElement = props.matchElement;

        return (<MatchElement key={matchId} {...matchProps}/>);
    }

    render() {
        const {showMatches, showBookmarks, displayMode, league} = this.props;

        if (league === undefined) {
            return false;
        }

        const isClosed = this.state.closed;

        const isSelected = (displayMode.type === DisplayMode.LEAGUE && displayMode.id == league.get('id'));

        const cls = 'league cf' + (isClosed ? ' closed' : '') + (isSelected ? ' selected' : '');

        const matches = showMatches === true ?
            league.get('matches').map(id => this.props.matches.get(id)).sort(matchSortFunc) :
            undefined;

        let favouritesCls = 'favourites';

        const favouriteState = league.get('favouriteState');

        if (favouriteState === FavouriteState.FULL) {
            favouritesCls += ' added';
        } else if (favouriteState === FavouriteState.PARTIAL) {
            favouritesCls += ' semi';
        }

        const boundLeagueClick = this._onLeagueClick.bind(this, league.get('sportId'), league.get('id'));

        return (
            <div className={cls}>
                <div className="league-title">
                    {showMatches && <a href="#" className="league-expand" onClick={this._onClick}>{'\u00A0'}</a>}
                    <a href="#" className="league-name" onClick={boundLeagueClick}>{league.get('name')}</a>
                    {showBookmarks && <a href="#" className={favouritesCls} onClick={this._onFavouriteClick}>
                        {'\u00A0'}
                    </a>}
                </div>
                {showMatches && !isClosed && <ul className="events-list">
                    {matches.map(m => League.renderMatch(m.get('id'), this.props))}
                </ul>}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/menu/League.jsx